export default __webpack_public_path__ + "static/media/790.db66d408.png";